import React, { Component } from "react";
import * as s from "./ShareResource.module.scss";
import { Col, Input, ShareButton, Button } from "src/views/shared/components";
import { ISettings } from "src/models";
import { EmailShareButton } from "react-share";
import { graphql, StaticQuery } from "gatsby";

interface Props {
  url: string;
  settings?: ISettings;
  title: string;
}

interface State {
  targetEmail: string;
  subject: string;
  body: string;
}

class ShareResourceComponent extends Component<Props, State> {
  constructor(props) {
    super(props);
    const { settings, title } = props;
    const { siteTitle } = settings?.generalSettings;
    this.state = {
      targetEmail: "",
      subject: `${siteTitle}: ${title}`,
      body: `I found a resource that I would like to share with you. The resource is called: ${title}, and it can be viewed on the following link. \n`,
    };
  }

  setTargetEmail = value => {
    this.setState({
      targetEmail: value,
    });
  };

  setSubject = value => {
    this.setState({
      subject: value,
    });
  };

  onSendEmail = () => {
    //TODO: implement when backend func exists
  };

  render() {
    const { url, settings } = this.props;
    const { generalSettings } = settings;

    let formattedUrl = url;
    if (url.startsWith("/")) {
      formattedUrl = generalSettings?.siteUrl + url;
    }

    return (
      <Col className={s.shareResourceContainer}>
        <h6 className={s.shareResourceEmailTitle}>Send an Email</h6>
        <Input
          type="textarea"
          id="share email subject"
          className={s.emailInput}
          placeholder={"Subject:"}
          label="Subject:"
          htmlFor="share-email-subject"
          onChange={this.setSubject}
          value={this.state.subject}
        />

        {
          //TODO: Add emailto later when backend email func exists
          /*<Input
          type="email"
          id="share email receiver"
          className={s.emailInput}
          placeholder={"Email to:"}
          label="Email to:"
          htmlFor="share-email-receiver"
          onChange={this.setTargetEmail}
          value={this.state.targetEmail}
        />*/
        }

        <EmailShareButton
          className={s.shareButton}
          url={formattedUrl}
          subject={
            this.state.subject ? this.state.subject : generalSettings.siteTitle
          }
          body={this.state.body}
        >
          {/** TODO: translation */}
          <div className={s.emailButton}>Send e-mail</div>
        </EmailShareButton>

        <h6 className={s.shareResourceSocialsTitle}>Share</h6>
        <div className={s.socialShareContainer}>
          <ShareButton type="whatsapp" url={formattedUrl} label="WhatsApp" />
          <div className={s.separator} />
          <ShareButton type="twitter" url={formattedUrl} label="Twitter" />
          <div className={s.separator} />
          <ShareButton type="facebook" url={formattedUrl} label="Facebook" />
          <div className={s.separator} />
          <ShareButton type="linkedin" url={formattedUrl} label="Linkedin" />
          <div className={s.separator} />
          <ShareButton type="skype" url={formattedUrl} label="Skype" />
        </div>
      </Col>
    );
  }
}

export const ShareResource = (props: Props) => (
  <StaticQuery
    query={query}
    render={data => {
      return <ShareResourceComponent {...props} settings={data.siteSettings} />;
    }}
  />
);

const query = graphql`
  query {
    ...siteSettingsFragment
  }
`;
